/* eslint-disable no-console */
import { Component, HostListener } from '@angular/core';
import { SideBar2Const, sideBarTutor1, sideBarTutor2 } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { AuthService } from '../../services/auth.service';
import { SocketService } from '../../services/socket.service';
import { Subject, takeUntil } from 'rxjs';
import { dashboardNotification } from '../../models/auth.model';

@Component({
  selector: 'mindbase-tutor-sidebar',
  templateUrl: './tutor-sidebar.component.html',
  styleUrl: './tutor-sidebar.component.scss'
})
export class TutorSidebarComponent {
  assetsConst = assets;
  public sideBar = sideBarTutor1;
  public sideBar2 = sideBarTutor2;
  protected SideBar2Const = SideBar2Const;
  public innerWidth = 0;
  public sidenavWidth = 5;
  public chatNotificationCount: number | undefined = 0;
  public notificationCount: number | undefined = 0;
  protected destroy : Subject<boolean> = new Subject<boolean>();
  constructor(public _authService: AuthService, private _socketService:SocketService) {
    this.getNotificationCount();
    this.getChatCount();
    this.chatCountUpdated();
    this.noti_received();
    this.clearNotifications();
  }
  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

  protected clearNotifications():void {
    this._authService.chatClicked.subscribe((res:any) => {
      if (res) {
        this.chatNotificationCount = 0; 
      }
    });
    this._authService.notificationClicked.subscribe((res:any) => {
      if (res) {
        this.notificationCount = 0; 
      }
    });
  }

  protected getNotificationCount(): void {
    this._authService
      .getNotificationCount()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: dashboardNotification) => {
          this.notificationCount = res.receiverNotificationCount;
        }
      });
  }

  protected getChatCount(): void {
    this._authService
      .getChatCount()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: dashboardNotification) => {
          this.chatNotificationCount = res.receiverChatCount;
        }
      });
  }

  private chatCountUpdated(): void {
    this._socketService.onEvent('chatCountUpdated').subscribe({
      next: (res:any) => {
        this.chatNotificationCount = res.data;
      }
    });
  }

  private noti_received(): void {
    this._socketService.onEvent('noti_received').subscribe({
      next: (res: any) => {
        this.notificationCount = res.data;
      }
    });
  }
  
}
